import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import LabelledSelect from '../components/LabelledSelect';
import LabelledTextInput from '../components/LabelledTextInput';
import Button from '../components/Button';
import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';
import Checkbox from '../../signup/Main/pages/Account/components/Checkbox';

const errorMessages = {
	shopName: 'Invalid shop name',
	contactName: 'Invalid contact name',
	email: 'Invalid email format',
	contactNumber: 'Invalid contact number',
	abn: 'ABN must be 11 characters',
	shopPostCode: 'Invalid post code format',
	source: 'Source must be defined',
	pleaseSpecify: 'Source must be specified',
};

const fields = [
	{ name: 'shopName', placeHolder: 'SHOP NAME' },
	{ name: 'contactName', placeHolder: 'CONTACT NAME' },
	{ name: 'email', placeHolder: 'EMAIL ADDRESS' },
	{ name: 'contactNumber', placeHolder: 'CONTACT NUMBER' },
	{ name: 'abn', placeHolder: 'ABN' },
	{ name: 'shopPostCode', placeHolder: 'SHOP POSTCODE' },
];

export default class Signup extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.validateField = this.validateField.bind(this);

		this.state = {
			submitted: false,
			shopName: '',
			contactName: '',
			email: '',
			contactNumber: '',
			abn: '',
			shopPostCode: '',
			source: '',
			pleaseSpecify: '',
			licensedPostOffice: false,
			errors: {},
		};
	}

	onChange(name) {
		return (e) => {
			const isCheckbox = name === 'licensedPostOffice';
			if (!isCheckbox && e.preventDefault) e.preventDefault();

			if (name === 'abn' && (e.target.value.length > 11 || isNaN(e.target.value))) {
				return;
			}

			if (name === 'shopPostCode' && (e.target.value.length > 4 || isNaN(e.target.value))) {
				return;
			}

			const newState = {
				[name]: isCheckbox ? !this.state.licensedPostOffice : e.target.value,
				errors: {},
			};

			if (name === 'source' && this.state.source !== 'Other') {
				newState.pleaseSpecify = '';
			}

			this.setState(newState);
		};
	}

	onSubmit(e) {
		e.preventDefault();

		/* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Submit Register your interest Click');

		if (this.state.dataSent) return;
		this.setState({ dataSent: true });

		const errors = {};
		fields.forEach((field) => {
			if (this.validateField(field.name, this.state[field.name])) {
				delete errors[field.name];
			} else {
				errors[field.name] = true;
			}
		});

		if (this.validateField('source', this.state.source)) {
			delete errors.source;
		} else {
			errors.source = true;
		}

		if (this.validateField('pleaseSpecify', this.state.pleaseSpecify)) {
			delete errors.pleaseSpecify;
		} else if (this.state.source === 'Other') {
			errors.pleaseSpecify = true;
		}

		if (Object.keys(errors).length > 0) {
			return this.setState({ dataSent: false, errors });
		}

		const body = {
			shopName: this.state.shopName,
			contactName: this.state.contactName,
			email: this.state.email,
			contactNumber: this.state.contactNumber,
			abn: this.state.abn,
			shopPostCode: this.state.shopPostCode,
			licensedPostOffice: this.state.licensedPostOffice,
			source: this.state.source,
			pleaseSpecify: this.state.pleaseSpecify,
		};
		
		axios.post('/api/account/signup', body).then(({ data }) => {
			if (!data.success) {
				if (data.error === 'existing-account') {
					return this.setState({
						dataSent: false,
						errors: {
							shopName: 'noop',
							email: `${this.state.shopName} is already registered to this email address. Contact support on 1800 817 483 for help.`,
						},
					});
				} else if (data.error === 'not-activated') {
					return this.setState({
						dataSent: false,
						errors: {
							shopName: 'noop',
							email: 'Agent needs to be activated before additional shops are registered. Contact support on 1800 817 483 for help.',
						},
					});
				} else if (data.error === 'validation errors') {
					const invalidFields = Object.keys(data.detail || {});
					return this.setState({ dataSent: false, errorMessage: `Invalid ${invalidFields.join(', ')}.` });
				}

				this.setState({ dataSent: false, errorMessage: data.error || 'Unknown error occured' });
			} else {
				this.setState({ dataSent: false, submitted: true });
			}
		}).catch((err) => {
			this.setState({ dataSent: false, error: err });
		});
	}

	validateField(field, value) {
		switch (field) {
			case 'shopName':
				return value.length > 0;
			case 'contactName':
				return value.length > 0;
			case 'email':
				return value.length > 0;
			case 'contactNumber':
				return value.length > 0;
			case 'abn':
				return value.length === 11;
			case 'shopPostCode':
				return value.length > 0;
			case 'source':
				return value !== '';
			case 'pleaseSpecify':
				return this.state.source === 'Other' && value.length > 0;
			default:
				return false;
		}
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Signup"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/agent"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								<MenuItem><a href="/agent/faqs">FAQs</a></MenuItem>
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<form style={{ display: 'flex', flexDirection: 'column', height: '100%' }} onSubmit={this.onSubmit}>
					{!this.state.submitted ? (
						<MessageSection
							style={{ marginTop: '50px' }}
							header="Register your interest"
							paragraph1="Apply below if you would like to become a blueshyft agent:"
						/>
					) : (
						<MessageSection
							header="Thank you!"
							paragraph1="Your registration of interest is currently pending admin approval."
							paragraph2="Please keep an eye out for an email in the next few days which will contain next steps"
						/>
					)}
					{this.state.errorMessage && !this.state.submitted ? (
						<div style={{ display: 'flex', justifyContent: 'center', }}>
							<Notice
								color="red"
								text={this.state.errorMessage}
								width="750"
							/>
						</div>
					) : null}
					{!this.state.submitted ? (
						<CenteredContainer>
							<Form>
								{fields.map((field, key) => (
									<Column key={key}>
										<LabelledTextInput
											placeHolder={field.placeHolder}
											name={field.name}
											type="text"
											value={this.state[field.name]}
											onChange={this.onChange(field.name)}
											error={this.state.errors[field.name]}
										/>
										{ this.state.errors[field.name] && this.state.errors[field.name] !== 'noop' ? (
											<Notice
												color="red"
												text={this.state.errors[field.name] === true ? errorMessages[field.name] : this.state.errors[field.name]}
												width="445px"
												marginTop="5px"
												// position="absolute"
											/>
										) : null}
									</Column>
								))}
								<Column>
									<LabelledSelect
										style={{ height: 45 }}
										placeHolder="HOW DID YOU HEAR ABOUT US?"
										name="source"
										type="text"
										value={this.state.source}
										onChange={this.onChange('source')}
										options={[
											'',
											'VANA',
											'XchangeIT',
											'Newspower',
											'Word of mouth',
											'Internet',
											'Social Media',
											'Other',
										]}
									/>
									{ this.state.errors.source ? (
										<Notice
											color="red"
											text={this.state.errors.source === true ? errorMessages.source : this.state.errors.source}
											width="445px"
											marginTop="5px"
											// position="absolute"
										/>
									) : null}
								</Column>
								{
									this.state.source === 'Other' ? (
										<Column>
											<LabelledTextInput
												placeHolder="PLEASE SPECIFY"
												name="pleaseSpecify"
												type="text"
												value={this.state.pleaseSpecify}
												onChange={this.onChange('pleaseSpecify')}
												error={this.state.errors['pleaseSpecify']}
											/>
											{ this.state.errors['pleaseSpecify'] && this.state.errors['pleaseSpecify'] !== 'noop' ? (
												<Notice
													color="red"
													text={this.state.errors['pleaseSpecify'] === true ? errorMessages['pleaseSpecify'] : this.state.errors['pleaseSpecify']}
													width="445px"
													marginTop="5px"
													// position="absolute"
												/>
											) : null}
										</Column>
									) : null
								}
								<Column style={{ width: '946px' }}>
									<Checkbox type="checkbox" name="isLicensed" label="test" checked={this.state.licensedPostOffice} onClick={this.onChange('licensedPostOffice')} style={{ width: '20px' }} /><span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px' }}>I am a Licensed Post Office (LPO)</span>
								</Column>
							</Form>
						</CenteredContainer>
					): null}
					{!this.state.submitted ? (
						<Button
							text="SUBMIT"
							onSubmit={this.onSubmit} 
						/>
					) : null}
				</form>
			</Container>
		);
	}
};

const Form = styled.form`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/Signup/index.js